export const UnderwriterMenuList = [
  {
    title: "Pending Applications",
    iconStyle: imagepaths.applicationCheckImg,
    iconActive: imagepaths.applicationCheckActiveImg,
    to: "/app/pendingapplications",
    id: "pendingapplications",
  }, {
    title: "Restructure Loan",
    iconStyle: imagepaths.applicationCheckImg,
    iconActive: imagepaths.applicationCheckActiveImg,
    to: "/app/restructureloan",
    id: "restructureloan",
  },
  {
    title: "My Applications",
    iconStyle: imagepaths.applicationCheckImg,
    iconActive: imagepaths.applicationCheckActiveImg,
    to: "/app/loanapplications",
    id: ["loanapplications", "loanapplicationsview"],
  },
  {
    title: "Loan Details",
    iconStyle: imagepaths.applicationCheckImg,
    iconActive: imagepaths.applicationCheckActiveImg,
    to: "/app/loandetails",
    id: "loandetails",
  },
  {
    title: "Know Your Customer",
    iconStyle: imagepaths.PersonSearchIcon,
    iconActive: imagepaths.PersonSearchIconActive,
    to: "/app/kyc",
    id: ["kyc", "creditscore"],
  },
  {
    title: "Dedup Check",
    iconStyle: imagepaths.DupeCheckIcon,
    iconActive: imagepaths.DupeCheckIconActive,
    to: "/app/dupecheck",
    id: "dupecheck",
  },
  // {
  //   title: "BSA",
  //   iconStyle: imagepaths.applicationCheckImg,
  //   iconActive: imagepaths.applicationCheckActiveImg,
  //   to: "/app/bankstatementanalyzer",
  //   id: "bankstatementanalyzer",
  // },
  // {
  //   title: "BSA 2",
  //   iconStyle: imagepaths.applicationCheckImg,
  //   iconActive: imagepaths.applicationCheckActiveImg,
  //   to: "/app/bsa",
  //   id: "bsa",
  // },
];
